import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Container, Typography, Stack, Card } from '@mui/material';
// sections
import { LoginForm } from '../sections/auth/login';
import logo from '../assets/logo.png';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(3),
  background: `radial-gradient(circle at 50% 0%, ${theme.palette.primary.lighter} 0%, ${theme.palette.background.default} 60%)`,
}));

const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 440,
  padding: theme.spacing(5, 4),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(4, 3),
  },
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  return (
    <>
      <Helmet>
        <title> Sign in · Vesuview </title>
      </Helmet>

      <StyledRoot>
        <Container maxWidth="sm" disableGutters sx={{ display: 'flex', justifyContent: 'center' }}>
          <StyledCard>
            <Stack alignItems="center" spacing={1.25} sx={{ mb: 4 }}>
              <img src={logo} alt="Vesuview" style={{ width: 124 }} />
              <Typography variant="h4" sx={{ textAlign: 'center' }}>
                Welcome back
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
                Sign in to your Vesuview admin
              </Typography>
            </Stack>

            <LoginForm />
          </StyledCard>
        </Container>
      </StyledRoot>
    </>
  );
}
